// BACK OFFICE API //

export const GetTradeInsertForm = ({
  basketId,
  sideId,
  coinDestinationId,
  coinSourceId,
}) =>
  `/Inv_Trade/GetTradeInsertForm?BasketId=${basketId}&CoinSourceId=${coinSourceId}&SideId=${sideId}&CoinDestinationId=${coinDestinationId}`;

export const GetTradeAmountMax = ({
  basketId,
  sideId,
  coinDestinationId,
  coinSourceId,
  brokerId
}) =>
  `/Inv_Trade/GetTradeAmountMax?BrokerId=${brokerId}&BasketId=${basketId}&CoinSourceId=${coinSourceId}&SideId=${sideId}&CoinDestinationId=${coinDestinationId}`;

export const TradeInsertInitial = "/Inv_Trade/TradeInsert"

export const GetTradeLast24HList = "/Inv_Trade/GetTradeLast24HList"

export const GetTradeForm = "/Inv_Trade/GetTradeForm"

export const GetTradeList = ({
  brokerId = 0,
  basketId = -1,
  coinSourceId = -1,
  coinDestinationId = -1,
  sideId = 0,
  typeId = 0,
  startDate = "",
  endDate = "",
  pageNumber = 1,
  pageSize = 10,
}) => `/Inv_Trade/GetTradeList?BrokerId=${brokerId}&BasketId=${basketId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&StartDate=${startDate}&EndDate=${endDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`

export const GetHistoryOrderForm = "/Inv_Order/GetHistoryOrderForm"

export const GetHistoryOrderList = ({
  brokerId = 0,
  basketId = -1,
  coinSourceId = -1,
  coinDestinationId = -1,
  sideId = 0,
  typeId = 0,
  startDate = "",
  endDate = "",
  pageNumber = 1,
  pageSize = 10,
}) => `/Inv_Order/GetHistoryOrderList?BrokerId=${brokerId}&BasketId=${basketId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&StartDate=${startDate}&EndDate=${endDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`

export const CancelOrder = "/Inv_Order/CancelOrder"

export const CheckOrder = "/Inv_Order/CheckOrder"

export const GetOpenOrderList = ({
  brokerId = 0,
  basketId = -1,
  coinSourceId = -1,
  coinDestinationId = -1,
  sideId = 0,
  typeId = 0,
  startDate = "",
  endDate = "",
  pageNumber = 1,
  pageSize = 10,
}) => `/Inv_Order/GetOpenOrderList?BrokerId=${brokerId}&BasketId=${basketId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&StartDate=${startDate}&EndDate=${endDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`

export const GetOpenOrderForm = "/Inv_Order/GetOpenOrderForm"